export const categories = [
  {
    slug: 'yule-quan-qian-gui-ze',
    name: '娱乐圈潜规则',
    description: '揭秘娱乐圈不为人知的潜规则内幕，导演选角、资源置换、行业黑幕深度起底',
    icon: 'ri-eye-off-line',
    color: 'accent',
  },
  {
    slug: 'wang-hong-ta-fang',
    name: '网红塌房事件',
    description: '24小时追踪网红翻车、人设崩塌、直播事故等最新塌房现场',
    icon: 'ri-building-2-line',
    color: 'primary',
  },
  {
    slug: 'ming-xing-ca-bian',
    name: '明星擦边黑料',
    description: '明星私生活、感情纠纷、争议言行等擦边黑料第一时间爆料',
    icon: 'ri-fire-line',
    color: 'accent',
  },
  {
    slug: 'jin-ri-da-gua',
    name: '今日大瓜',
    description: '每日最新最热娱乐圈大瓜汇总，不错过任何一个爆炸性新闻',
    icon: 'ri-chat-new-line',
    color: 'primary',
  },
  {
    slug: 'li-nian-he-ji',
    name: '历年大瓜合集',
    description: '盘点历年娱乐圈经典大瓜，从经典到冷门，完整时间线梳理',
    icon: 'ri-archive-line',
    color: 'secondary',
  },
  {
    slug: 'zhi-bo-fan-che',
    name: '直播翻车现场',
    description: '主播、明星直播中的翻车名场面，实时录屏与深度分析',
    icon: 'ri-live-line',
    color: 'secondary',
  },
];

export const featuredArticles = [
  {
    slug: 'ding-liu-nan-xing-qian-gui-ze-nei-mu',
    title: '某顶流男星被曝选角潜规则，多名女演员实名举报',
    excerpt: '据知情人士透露，该男星在多部热播剧中利用选角话语权，对多名新人女演员提出不当要求。目前已有三位女演员通过社交媒体实名发声，引发业内震动。',
    category: '娱乐圈潜规则',
    categorySlug: 'yule-quan-qian-gui-ze',
    imageSeq: 'featured-dingliu-2026',
    imageQuery: 'Dramatic%20dark%20stage%20with%20a%20single%20spotlight%20on%20an%20empty%20director%20chair%2C%20atmospheric%20mysterious%20mood%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20film%20noir%20style%2C%20minimalist%20composition%2C%20warm%20amber%20spotlight%20against%20dark%20background%2C%20editorial%20photography%20quality',
    date: '2026-07-05',
    hot: true,
    views: 1280000,
  },
  {
    slug: 'qian-wan-fen-wang-hong-bei-pin-pai-jie-yue',
    title: '千万粉网红直播中爆粗口，三大品牌连夜解约',
    excerpt: '拥有1200万粉丝的知名网红在昨晚直播中因不满产品评价当场爆粗口，引发舆论哗然。截至今日上午，已有三家合作品牌宣布终止合作，预估损失超千万。',
    category: '网红塌房事件',
    categorySlug: 'wang-hong-ta-fang',
    imageSeq: 'featured-wanghong-2026',
    imageQuery: 'A%20shattered%20smartphone%20screen%20on%20a%20dark%20table%20with%20broken%20glass%20pieces%20scattered%2C%20dramatic%20red%20and%20black%20lighting%2C%20chaotic%20atmosphere%2C%20metaphor%20for%20social%20media%20crisis%2C%20dark%20cinematic%20mood%2C%20editorial%20photography%2C%20high%20contrast',
    date: '2026-07-04',
    hot: true,
    views: 960000,
  },
  {
    slug: 'zhi-ming-dao-yan-bei-zhi-kong-xing-sao-rao',
    title: '知名导演被指控片场性骚扰，剧组紧急换人',
    excerpt: '某知名商业片导演在拍摄期间被多位剧组工作人员指控存在不当行为。制片方已紧急发布声明，宣布更换导演并启动内部调查程序。',
    category: '娱乐圈潜规则',
    categorySlug: 'yule-quan-qian-gui-ze',
    imageSeq: 'featured-daoyan-2026',
    imageQuery: 'An%20empty%20film%20set%20with%20professional%20camera%20equipment%20silhouetted%20against%20a%20dark%20studio%20background%2C%20eerie%20atmosphere%2C%20single%20overhead%20light%20casting%20long%20shadows%2C%20cinematic%20composition%2C%20film%20noir%20aesthetic%2C%20mysterious%20and%20tense%20mood',
    date: '2026-07-03',
    hot: false,
    views: 720000,
  },
];

export const latestArticles = [
  {
    slug: 'nv-tuan-cheng-yuan-lian-ai-bao-guang',
    title: '女团成员地下恋曝光，与圈外男友同居三年',
    excerpt: '当红女团成员被拍到与圈外男友多次出入同一小区，疑似已同居三年。粉丝后援会已发布联合声明要求经纪公司回应。',
    category: '明星擦边黑料',
    categorySlug: 'ming-xing-ca-bian',
    imageSeq: 'latest-nvtuan-2026',
    imageQuery: 'A%20blurred%20couple%20silhouette%20walking%20in%20a%20dark%20alley%20at%20night%2C%20paparazzi%20style%20photography%2C%20grainy%20film%20texture%2C%20mysterious%20atmosphere%2C%20warm%20street%20lamp%20light%2C%20voyeuristic%20perspective%2C%20editorial%20quality',
    date: '2026-07-06',
    views: 560000,
  },
  {
    slug: 'zhu-bo-kao-yan-zhuang-che',
    title: '主播考研人设翻车，被扒学历造假全程伪造',
    excerpt: '拥有500万粉丝的"考研主播"被网友扒出学历造假，其展示的研究生录取通知书、校园照片均为PS伪造。目前该主播账号已设为私密。',
    category: '网红塌房事件',
    categorySlug: 'wang-hong-ta-fang',
    imageSeq: 'latest-kaoyan-2026',
    imageQuery: 'A%20fake%20diploma%20burning%20with%20flames%20on%20a%20dark%20surface%2C%20dramatic%20fire%20lighting%2C%20symbolic%20of%20exposed%20lies%2C%20dark%20background%2C%20cinematic%20composition%2C%20high%20contrast%2C%20editorial%20photography',
    date: '2026-07-05',
    views: 890000,
  },
  {
    slug: 'ding-liu-hua-dan-zheng-fan-wei-da-zhan',
    title: '两大顶流花旦片场争执视频流出，双方粉丝互撕',
    excerpt: '某古装剧拍摄现场，两位一线女星因戏份问题发生激烈争执，现场视频被工作人员偷拍流出。双方粉丝已在社交平台展开大规模互撕。',
    category: '明星擦边黑料',
    categorySlug: 'ming-xing-ca-bian',
    imageSeq: 'latest-huadan-2026',
    imageQuery: 'Two%20spotlights%20crossing%20and%20clashing%20in%20a%20dark%20theater%20space%2C%20dramatic%20confrontation%20metaphor%2C%20intense%20warm%20and%20cool%20lighting%20contrast%2C%20cinematic%20atmosphere%2C%20abstract%20composition%2C%20editorial%20photography',
    date: '2026-07-04',
    views: 1500000,
  },
  {
    slug: 'jie-mu-zu-bao-liao-tou-piao-zuo-jia',
    title: '选秀节目被曝投票造假，节目组凌晨紧急回应',
    excerpt: '某热门选秀节目被淘汰选手发文爆料，称节目组操控投票结果、内定晋级名单。节目组凌晨发布声明否认，但网友已扒出多项证据。',
    category: '娱乐圈潜规则',
    categorySlug: 'yule-quan-qian-gui-ze',
    imageSeq: 'latest-xuanxiu-2026',
    imageQuery: 'A%20tampered%20voting%20ballot%20box%20in%20dramatic%20lighting%2C%20shadowy%20hands%20manipulating%20papers%2C%20dark%20corrupt%20atmosphere%2C%20film%20noir%20style%2C%20high%20contrast%20black%20and%20red%20tones%2C%20editorial%20photography',
    date: '2026-07-03',
    views: 670000,
  },
  {
    slug: 'zhi-ming-zhu-bo-tao-shui-bei-fa',
    title: '知名带货主播涉嫌偷税被查，直播间已停播',
    excerpt: '据税务部门消息，某头部带货主播因涉嫌偷逃税款被立案调查。该主播所有社交账号已暂停更新，原定今晚的直播也已取消。',
    category: '网红塌房事件',
    categorySlug: 'wang-hong-ta-fang',
    imageSeq: 'latest-taoshui-2026',
    imageQuery: 'An%20empty%20luxurious%20livestreaming%20room%20with%20dim%20lights%2C%20abandoned%20products%20on%20desk%2C%20cerie%20silence%20atmosphere%2C%20dark%20and%20cold%20mood%2C%20cinematic%20composition%2C%20editorial%20photography',
    date: '2026-07-02',
    views: 2100000,
  },
  {
    slug: 'yi-xian-nan-xing-hun-wai-qing-bao-guang',
    title: '一线男星婚外情曝光，原配发文"好自为之"',
    excerpt: '某已婚一线男星被拍到与神秘女子同游海外，其妻子随后在社交平台发布"好自为之"四字，疑似证实婚变传闻。',
    category: '明星擦边黑料',
    categorySlug: 'ming-xing-ca-bian',
    imageSeq: 'latest-hunwai-2026',
    imageQuery: 'A%20wedding%20ring%20shattered%20on%20a%20dark%20marble%20surface%2C%20dramatic%20lighting%2C%20symbolic%20of%20broken%20marriage%2C%20dark%20melancholic%20atmosphere%2C%20high%20contrast%2C%20editorial%20photography',
    date: '2026-07-01',
    views: 1800000,
  },
  {
    slug: 'wang-luo-ge-shou-chao-xi-feng-bo',
    title: '网络歌手新歌被指抄袭，原唱发律师函警告',
    excerpt: '近期爆火的网络歌手新歌被扒旋律与某韩国歌曲高度相似，原唱经纪公司已发出律师函。该歌手发文否认抄袭但未提供有力证据。',
    category: '今日大瓜',
    categorySlug: 'jin-ri-da-gua',
    imageSeq: 'latest-chaoxi-2026',
    imageQuery: 'Two%20musical%20notes%20colliding%20and%20shattering%20in%20mid%20air%2C%20dramatic%20dark%20background%2C%20golden%20and%20red%20accents%2C%20symbolic%20of%20music%20plagiarism%20controversy%2C%20cinematic%20composition%2C%20editorial%20quality',
    date: '2026-06-30',
    views: 430000,
  },
  {
    slug: 'zong-yi-jie-mu-hei-mu-jie-mi',
    title: '综艺节目黑幕大揭秘：冠军早已内定？',
    excerpt: '某竞技类综艺节目收官后，多位参赛选手联合爆料节目组操纵比赛结果。知情人士透露冠军人选在节目录制前就已确定。',
    category: '娱乐圈潜规则',
    categorySlug: 'yule-quan-qian-gui-ze',
    imageSeq: 'latest-zongyi-2026',
    imageQuery: 'A%20dark%20backstage%20of%20a%20TV%20show%20with%20manipulated%20scripts%20and%20puppet%20strings%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20editorial%20photography%2C%20high%20contrast',
    date: '2026-06-29',
    views: 950000,
  },
  {
    slug: 'duan-shi-pin-hong-ren-bei-bao-jia-bao',
    title: '短视频红人被曝家暴，前妻晒伤情鉴定书',
    excerpt: '拥有800万粉丝的短视频创作者被前妻发文控诉家暴，并晒出多份伤情鉴定报告和报警记录。该红人暂未回应，评论区已沦陷。',
    category: '网红塌房事件',
    categorySlug: 'wang-hong-ta-fang',
    imageSeq: 'latest-jiabao-2026',
    imageQuery: 'A%20cracked%20family%20photo%20frame%20on%20a%20dark%20wooden%20floor%2C%20dramatic%20shadow%20lighting%2C%20melancholic%20and%20heavy%20atmosphere%2C%20symbolic%20of%20domestic%20violence%20revelation%2C%20cinematic%20composition',
    date: '2026-06-28',
    views: 1200000,
  },
  {
    slug: 'ming-xing-kai-wang-hong-dian-bei-zhi-jia-ge-xu-gao',
    title: '明星开网红店被指价格虚高，成本不到售价一成',
    excerpt: '某明星开设的网红餐厅被前员工爆料，标价298元的招牌菜实际成本不到30元。网友纷纷晒出消费体验，评分暴跌至2.3分。',
    category: '今日大瓜',
    categorySlug: 'jin-ri-da-gua',
    imageSeq: 'latest-canting-2026',
    imageQuery: 'A%20luxurious%20restaurant%20table%20with%20overpriced%20dishes%20under%20dim%20dramatic%20lighting%2C%20empty%20chairs%2C%20abandoned%20atmosphere%2C%20dark%20mood%2C%20editorial%20photography%2C%20high%20contrast',
    date: '2026-06-27',
    views: 760000,
  },
];

export const classicArticles = [
  {
    slug: 'jing-dian-xing-sao-rao-an-jian-pan-dian',
    title: '十年盘点：娱乐圈性骚扰案件全记录',
    excerpt: '从2016年到2026年，我们整理了娱乐圈公开报道的性骚扰案件，涉及导演、演员、制片人等多个角色，揭示行业系统性问题的冰山一角。',
    category: '历年大瓜合集',
    categorySlug: 'li-nian-he-ji',
    imageSeq: 'classic-xingsaorao-2026',
    imageQuery: 'A%20timeline%20of%20newspaper%20clippings%20pinned%20on%20a%20dark%20cork%20board%2C%20dramatic%20lighting%2C%20investigative%20journalism%20aesthetic%2C%20noir%20atmosphere%2C%20editorial%20photography',
    date: '2026-06-15',
    views: 3200000,
  },
  {
    slug: 'wang-hong-jing-ji-xia-de-fan-che-shi-jian',
    title: '网红经济泡沫下，那些年我们一起追过的塌房现场',
    excerpt: '从最早期的网红到现在，塌房事件层出不穷。我们梳理了近五年最具代表性的20起网红塌房事件，分析其背后的共性与行业反思。',
    category: '历年大瓜合集',
    categorySlug: 'li-nian-he-ji',
    imageSeq: 'classic-wanghong-2026',
    imageQuery: 'Collapsed%20house%20of%20cards%20made%20of%20social%20media%20icons%2C%20dramatic%20lighting%2C%20metaphor%20for%20influencer%20downfall%2C%20dark%20background%2C%20editorial%20photography%2C%20cinematic%20composition',
    date: '2026-05-20',
    views: 2800000,
  },
  {
    slug: 'ming-xing-tao-shui-an-jian-zong-he',
    title: '明星偷税漏税案件大盘点：从范冰冰到当下',
    excerpt: '偷税漏税一直是娱乐圈的高发问题。本文梳理了近年来被查处的主要明星偷税案件，分析监管趋严背景下行业的税务合规变化。',
    category: '历年大瓜合集',
    categorySlug: 'li-nian-he-ji',
    imageSeq: 'classic-taoshui-2026',
    imageQuery: 'A%20stack%20of%20tax%20documents%20under%20dramatic%20interrogation%20room%20lighting%2C%20dark%20atmosphere%2C%20investigative%20mood%2C%20film%20noir%20style%2C%20high%20contrast%2C%20editorial%20photography',
    date: '2026-04-10',
    views: 4100000,
  },
];

export const allArticles = [...featuredArticles, ...latestArticles, ...classicArticles];

export const faqItems = [
  {
    question: '黑料六点半的内容来源可靠吗？',
    answer: '我们坚持多方交叉验证原则，每条爆料均来源于公开报道、当事人社交账号或可靠线人提供的信息。我们会对信息进行初步核实后再发布，但对于未经法律程序确认的内容，请读者理性看待。',
  },
  {
    question: '如何在黑料六点半投稿爆料？',
    answer: '您可以通过"关于我们"页面的联系方式投稿。我们承诺对所有爆料人信息严格保密，采用加密通道传输，确保您的隐私安全。',
  },
  {
    question: '黑料六点半更新频率是怎样的？',
    answer: '我们团队24小时轮班监控娱乐圈动态，确保重大爆料第一时间推送。常规内容每日至少更新3-5篇，突发大瓜不受时间限制随时更新。',
  },
  {
    question: '被爆料方要求删帖怎么办？',
    answer: '我们尊重事实与法律。如果爆料内容存在事实性错误，我们会在核实后及时更正并致歉。但对于真实且符合公众知情权的报道，我们坚持不因外部压力而删帖的原则。',
  },
  {
    question: '黑料六点半和51黑料吃瓜网是什么关系？',
    answer: '黑料六点半与51黑料吃瓜网是战略合作伙伴关系。双方共享部分爆料线索资源，但各自保持独立的编辑方针和内容审核标准，共同为吃瓜群众提供更全面的娱乐八卦资讯。',
  },
];

export const aboutInfo = {
  brandName: '黑料六点半',
  tagline: '吃瓜无罪，八卦有理',
  intro: '黑料六点半成立于2020年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为吃瓜群众提供最及时、最全面、最真实的娱乐圈爆料资讯。从娱乐圈潜规则到网红塌房事件，从明星私生活到行业黑幕，黑料六点半始终站在吃瓜第一线。',
  mission: '坚持真实爆料，拒绝虚假炒作。我们相信公众有权了解娱乐圈的真实面貌，八卦不仅是消遣，更是对行业乱象的监督。',
  stats: [
    { label: '累计爆料', value: '12,800+', desc: '篇独家爆料覆盖全网' },
    { label: '日均访问', value: '500万+', desc: '吃瓜群众每日在线蹲瓜' },
    { label: '合作媒体', value: '200+', desc: '家主流媒体与自媒体伙伴' },
    { label: '爆料线索', value: '99.7%', desc: '匿名爆料人隐私保护率' },
  ],
  contact: {
    email: 'tips@heilia630.com',
    wechat: 'heilia630',
    address: '北京市朝阳区传媒产业园区',
  },
};